import React from 'react';
import { connect } from 'react-redux';

import { setAccountsFilter } from 'actions/accountsActions';
import { accountFilters } from 'constants/filters';

function CustomAccountsFilter({ setAccountsFilter, activeFilter }) {
  const hasActiveFilter = !!activeFilter;
  return (
    <div className="CustomAccountsFilter">
      <span className="CustomAccountsFilter__header">Filter Accounts:</span>
      <div className="CustomAccountsFilter__filter-options">
        {Object.values(accountFilters).map((option) => (
          <label key={option}>
            <input
              type="radio"
              name="filter"
              id={option}
              defaultChecked={
                hasActiveFilter
                  ? option === activeFilter
                  : option === accountFilters.ALL
              }
              onChange={() => setAccountsFilter(option)}
            />
            {`${option}`}
          </label>
        ))}
      </div>
    </div>
  );
}

const mapState = (state) => {
  return {
    activeFilter: state.accounts.filter,
  };
};

const mapDispatch = {
  setAccountsFilter,
};

export default connect(mapState, mapDispatch)(CustomAccountsFilter);
